export default __webpack_public_path__ + "static/media/default_avatar.f474fb2a.svg";